import { useTranslation } from 'react-i18next'

import { URL_CUSTOMER_PROFILE } from '@shared/contants'
import { useLocalizedNavigate as useNavigate } from '@shared/lib/locale'

export default function VerificationFailure ({
  metadata,
}: {
  metadata?: Record<string, unknown>
}) {
  const { t } = useTranslation('payment')
  const navigate = useNavigate()

  const handleRetry = () => {
    navigate(URL_CUSTOMER_PROFILE)
  }

  const errorMessage = metadata?.error && typeof metadata.error === 'string' ? metadata.error : null

  return (
    <div className="verification-failure">
      <div className="verification-failure__icon">✕</div>
      <h1 className="verification-failure__title">
        {t('verification.failure.title')}
      </h1>
      <p className="verification-failure__message">
        {t('verification.failure.message')}
      </p>
      {errorMessage && (
        <p className="verification-failure__error">
          {t('verification.failure.error')}: {errorMessage}
        </p>
      )}
      <button
        className="verification-failure__button"
        onClick={handleRetry}
        type="button"
      >
        {t('verification.failure.button')}
      </button>
    </div>
  )
}
